import React from 'react';
import classNames from 'classnames';
import { getColorClasses } from '@src/utils/colorClasses';
import { Colors } from '@src/types/colors';
import styles from './SunraySVG.module.scss';

interface SunraySVG {
  color: Colors;
}

const SunraySVG: React.FC<SunraySVG> = ({ color }) => {
  const fillColor = classNames(
    styles.sunraySvg,
    getColorClasses(color, styles)
  );

  return (
    <svg viewBox="0 0 271 134" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M70.5 134c.097-5.127.716-10.655 1.925-15.432L4.253 105.993C3.193 111.551.358 128.224 0 134h70.5ZM137.916 53.971 129.908-.002c-5.84.241-11.584.854-17.211 1.816l10.239 68.434a66.143 66.143 0 0 1 13.308-1.345c5.655 0 11.149.713 16.386 2.058l9.256-68.539A135.319 135.319 0 0 0 144.9.195l-6.984 53.784v-.008ZM216 134h54c.141-8.628-1.443-24.14-2.607-28.631l-67.608 13.038a65.974 65.974 0 0 1 1.487 13.944c0 .456.012 1.194 0 1.649h14.777H216ZM7.958 90.006l65.557 24.711a65.756 65.756 0 0 1 15.403-25.742L32.93 47.008a135.734 135.734 0 0 0-10.335 13.67l45.064 33.424L14.78 74.096a134.185 134.185 0 0 0-6.823 15.91ZM49.545 30.731 92.768 85.29a65.678 65.678 0 0 1 26.278-14.122L92.788 6.786a135.119 135.119 0 0 0-15.882 6.432l21.062 50.9-34.39-43.517a136.015 136.015 0 0 0-14.037 10.13h.004ZM179.271 7.056l-23.998 64.647a65.74 65.74 0 0 1 25.698 14.746l41.1-55.411a136.319 136.319 0 0 0-13.844-10.086l-31.86 43.408 18.887-50.686a134.785 134.785 0 0 0-15.987-6.618h.004ZM236.828 45.289l-53.019 43.944a65.783 65.783 0 0 1 15.145 25.472l63.338-27.478a135.26 135.26 0 0 0-7.089-15.596l-49.374 21.718 41.656-34.442a135.67 135.67 0 0 0-10.661-13.622l.004.004Z"
        className={fillColor}
      />
    </svg>
  );
};

export default SunraySVG;
